import { render, staticRenderFns } from "./RankCardChart.vue?vue&type=template&id=88522fc6&scoped=true&"
import script from "./RankCardChart.vue?vue&type=script&lang=js&"
export * from "./RankCardChart.vue?vue&type=script&lang=js&"
import style0 from "./RankCardChart.vue?vue&type=style&index=0&id=88522fc6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88522fc6",
  null
  
)

export default component.exports